/**
 * QuickLogSheet (PH4-8) — bottom-sheet wrapper around QuickLogForm.
 *
 * Closes the route-vs-sheet mismatch: the FAB on Today/Plan now opens
 * a sheet instead of a full /quick-log route navigation, matching the
 * mobile mockup pattern where quick-actions stay anchored to context.
 * The /quick-log route stays as a deep-link fallback.
 */
import { useTranslation } from "react-i18next";

import { BottomSheet } from "../BottomSheet";
import { QuickLogForm } from "./QuickLogForm";

export interface QuickLogSheetProps {
  open: boolean;
  onClose: () => void;
}

export function QuickLogSheet({ open, onClose }: QuickLogSheetProps) {
  const { t } = useTranslation("quick_log");
  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title={t("title")}
      subtitle={t("intro")}
      testId="quick-log-sheet"
    >
      <QuickLogForm onSaved={onClose} hideShortcutHint />
    </BottomSheet>
  );
}
